var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { RetrievePnrLocatorComponent } from './retrieve-pnr-locator.component';
import { Router } from '@angular/router';
import { Validators, FormBuilder } from '@angular/forms';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { takeWhile } from 'rxjs/operators';
var INDRARetrievePnrLocatorComponent = /** @class */ (function (_super) {
    __extends(INDRARetrievePnrLocatorComponent, _super);
    function INDRARetrievePnrLocatorComponent(fb, router, ibeAdminService, ibeAdminConfigService, store) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.router = router;
        _this.ibeAdminService = ibeAdminService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.store = store;
        _this.groupRequiredLetter = 'G';
        _this.submitted = false;
        _this.submitTry = false;
        _this.allSubs = [];
        _this.userInfo$ = _this.store.select(fromStore.getUserInfo);
        _this.isLoggedIn = false;
        _this.isAlive = true;
        _this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (user) {
            if (user) {
                _this.token = user.flyTapLogin;
                _this.isLoggedIn = true;
                _this.userInfo = user;
            }
            else {
                _this.token = null;
                _this.isLoggedIn = false;
                _this.userInfo = null;
            }
        });
        return _this;
    }
    INDRARetrievePnrLocatorComponent.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            pnr: [
                '',
                [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.maxLength(13),
                    Validators.pattern('^([A-Za-z0-9_]{6}|047([0-9]{10}))$')
                ]
            ],
            last_name: ['', [Validators.required, Validators.pattern('^[^0-9]*$')]]
        });
        this.onChanges();
    };
    INDRARetrievePnrLocatorComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubs; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRARetrievePnrLocatorComponent.prototype.onChanges = function () {
        var _this = this;
        var formValueSub = this.form.valueChanges.subscribe(function (val) {
            _this.submitTry = false;
        });
        this.allSubs.push(formValueSub);
    };
    INDRARetrievePnrLocatorComponent.prototype.INDRA_showErros = function () {
        return !this.form.valid && this.submitTry;
    };
    INDRARetrievePnrLocatorComponent.prototype.INDRA_PNRhasError = function () {
        return this.INDRA_showErros() && (this.form.controls['pnr'].hasError('required')
            || this.form.controls['pnr'].hasError('pattern') || this.form.controls['pnr'].hasError('minlength')
            || this.form.controls['pnr'].hasError('maxlength'));
    };
    INDRARetrievePnrLocatorComponent.prototype.INDRA_LastNamehasError = function () {
        return this.INDRA_showErros() && (this.form.controls['last_name'].hasError('required')
            || this.form.controls['last_name'].hasError('pattern'));
    };
    INDRARetrievePnrLocatorComponent.prototype.INDRA_findBooking = function () {
        // https://tpuat.suitairibe.com/my-bookings/details?pnr=${PNR}&lastname=${surname}&source=flytap&market=<market>&language=<language>
        this.submitTry = true;
        // stop here if form is invalid
        if (this.form.valid) {
            this.submitted = true;
            var key = 'externalURLs.myTripsManageBooking';
            var url = this.ibeAdminConfigService.getConfigurationValue(key);
            var myBookingsUrl = url.replace('${surname}', this.form.value.last_name).replace('${PNR}', this.form.value.pnr.toUpperCase());
            myBookingsUrl += '?source=flytap';
            var selectedMarketCode = sessionStorage.getItem('market');
            var selectedLanguageCode = sessionStorage.getItem('language');
            if (selectedMarketCode) {
                myBookingsUrl += '&market=' + selectedMarketCode;
            }
            if (selectedLanguageCode) {
                myBookingsUrl += '&language=' + selectedLanguageCode;
            }
            if (this.isLoggedIn && this.token) {
                myBookingsUrl += '&uid=' + this.token;
            }
            return window.open(myBookingsUrl);
        } /* else if (this.form.invalid) {
            const firstElementWithError = document.querySelectorAll('form .ng-invalid');
            if (firstElementWithError.length) {
                const elFirstElementWithError = firstElementWithError[0].getElementsByTagName('input')[0] as HTMLElement;
                elFirstElementWithError.scrollIntoView({block: "center", inline: "center", behavior: "smooth"});
                elFirstElementWithError.focus();
            }
        } */
    };
    return INDRARetrievePnrLocatorComponent;
}(RetrievePnrLocatorComponent));
export { INDRARetrievePnrLocatorComponent };
